var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {GetFirmwareListAsync as InvokeAsync , GetFirmwareListSync as InvokeSync}

async function GetFirmwareListAsync(LoginToken,Filter,LastKey,Limit)
{
    var GetFirmwareListPromise = new Promise((resolve, reject) => {
        GetFirmwareListSync(LoginToken,Filter,LastKey,Limit,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await GetFirmwareListPromise;
}

function GetFirmwareListSync(LoginToken,Filter,LastKey,Limit,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/GetFirmwareList',                
        data  : {
            AppID     :KEYS.AWS_APPID,
            LastKey   :LastKey,
            Filter    :Filter ,
            Limit     :Limit  ,
            LoginToken:LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
